import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Btn, Input, Field } from "@/components/ui-kit";
import { ShieldCheck } from "lucide-react";


export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email.trim(), password);
    setBusy(false);
    if (ok) navigate("/");
  };

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      {/* Left banner */}
      <div className="relative hidden w-1/2 flex-col justify-between overflow-hidden border-r border-border bg-[#0B0E14] p-10 text-white lg:flex">
        <div className="tactical-grid absolute inset-0 opacity-40" />
        <div className="scanline-overlay absolute inset-0" />
        <div className="relative flex items-center gap-3">
          <img src="/logo-amax.png" alt="amax" className="h-10 w-auto brightness-0 invert" />
          <div className="h-8 w-px bg-white/25" />
          <span className="font-heading text-xl font-extrabold uppercase tracking-tight">RepairOps Command Hub</span>
        </div>
        <div className="relative space-y-4">
          <h1 className="font-heading text-4xl font-extrabold uppercase leading-tight tracking-tight lg:text-5xl">
            Electronics Repair &<br /> Project Ops
          </h1>
          <p className="max-w-md text-sm text-slate-400">
            Inward/Outward logistics, fault diagnostics, inventory control, and classified project
            management — unified in one high-density tactical operations console.
          </p>
          <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-emerald-400">
            <ShieldCheck size={16} /> MIL-STD Audit-Ready · RBAC Enforced
          </div>
        </div>
        <div className="relative font-mono text-[10px] uppercase tracking-widest text-slate-500">
          Army · Navy · Air Force · Commercial
        </div>
      </div>

      {/* Form */}
      <div className="flex w-full flex-col items-center justify-center p-6 lg:w-1/2">
        <div className="w-full max-w-sm space-y-6">
          <div>
            <div className="mb-1 flex items-center gap-2 lg:hidden">
              <img src="/logo-amax.png" alt="amax" className="h-7 w-auto dark:brightness-0 dark:invert" />
              <span className="font-heading text-lg font-extrabold uppercase">RepairOps</span>
            </div>
            <h2 className="font-heading text-2xl font-bold uppercase tracking-tight">Secure Sign In</h2>
            <p className="text-sm text-muted-foreground">Authenticate to access the operations hub.</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <Field label="Email" required>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required />
            </Field>
            <Field label="Password" required>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </Field>
            <Btn type="submit" size="lg" className="w-full" disabled={busy} data-testid="login-submit">
              {busy ? "Authenticating…" : "Sign In"}
            </Btn>
          </form>
          <div className="flex items-center justify-between text-xs">
            <Link to="/forgot-password" className="text-muted-foreground hover:text-primary" data-testid="forgot-password-link">Forgot password?</Link>
            <Link to="/register" className="font-semibold text-primary hover:underline" data-testid="register-link">Request access</Link>
          </div>

        </div>
      </div>
    </div>
  );
}
